import React from 'react';
import ModalWaybillOptionComponent from '../Component/ModalWaybillOptionComponent';
import { Radio } from 'antd';
interface IProps {
  modalWaybillOption: boolean;
  setModalWaybillOption: (value: boolean) => void;
  dataWaybillOption: any[];
  setDataWaybillOption: (value: any[] | null) => void;
  selectedWaybill: string | null;
  setSelectedWaybill: (value: string | null) => void;
  handleSubmitScanDocument: (values: any) => void;
  selectedCustomerProduct: any;
  selectedTypePeriode: any;
  selectedPeriodeDelivery: any;
  isLoadingMutation: boolean;
}
export default function ModalWaybillOptionContainer(props: IProps) {
  const {
    modalWaybillOption,
    setModalWaybillOption,
    dataWaybillOption,
    setDataWaybillOption,
    selectedWaybill,
    setSelectedWaybill,
    handleSubmitScanDocument,
    isLoadingMutation,
  } = props;

  const handleCancel = () => {
    setModalWaybillOption(false);
    setDataWaybillOption(null);
    setSelectedWaybill(null);
  };
  const columnData = [
    {
      title: <b>Waybill</b>,
      dataIndex: 'waybill',
      key: 'waybill',
      width: 30,
    },
    {
      title: <b>Barcode</b>,
      dataIndex: 'barcode',
      key: 'barcode',
      width: 30,
    },
    {
      title: <b>Tanggal Cycle</b>,
      dataIndex: 'cycle',
      key: 'cycle',
      width: 30,
    },
    {
      title: <b>Nama</b>,
      dataIndex: 'name',
      key: 'name',
      width: 30,
    },
    {
      key: 'action',
      width: 30,
      render: record => {
        return (
          <Radio.Group>
            <Radio
              key={record.waybill}
              value={selectedWaybill}
              onClick={() => setSelectedWaybill(record.waybill)}
              checked={
                selectedWaybill ? record.waybill === selectedWaybill : false
              }
            ></Radio>
          </Radio.Group>
        );
      },
    },
  ];

  const handleScanWaybill = () => {
    const {
      selectedCustomerProduct,
      selectedTypePeriode,
      selectedPeriodeDelivery,
    } = props;
    const values: any = {
      typePeriode: selectedTypePeriode,
      periodeDelivery: selectedPeriodeDelivery,
      customerProduct: selectedCustomerProduct,
      typeScan: 'waybill',
      scan: selectedWaybill,
    };
    handleSubmitScanDocument(values);
  };

  return (
    <ModalWaybillOptionComponent
      modalWaybillOption={modalWaybillOption}
      handleCancel={handleCancel}
      dataWaybillOption={dataWaybillOption}
      columnData={columnData}
      handleScanWaybill={handleScanWaybill}
      selectedWaybill={selectedWaybill}
      isLoadingMutation={isLoadingMutation}
    />
  );
}
